<template>
  <tr>
    <td>
      {{ name }}
    </td>
    <td>
      <span class="text-primary cursor--pointer" @click="show">
        <i class="fa fa-info-circle"></i> {{ articleName }}
      </span>
    </td>

    <td v-if="cloud.status < PRINT_CLOUD_STATUS_FINISHED">
      <span v-if="configuration.is_logo_print && configuration.upload !== null && configuration.upload.file_exists"
        class="text-primary cursor--pointer"
        @click="download">
        <i class="fa fa-download"></i> {{ configuration.upload.original_name }}
      </span>

      <template v-if="configuration.is_logo_print && configuration.upload !== null && !configuration.upload.file_exists">
        <span class="text-primary">{{ configuration.upload.original_name }}</span><br>
        <span  class="mr-2 bg-danger">
          <i class="fa fa-warning text-danger"></i> {{ $t('configurator.labels.file_missing') }}
        </span>
      </template>

      <span v-if="configuration.is_logo_print && configuration.upload === null" class="mr-2 bg-warning">
        <i class="fa fa-warning text-warning"></i> {{ $t('configurator.labels.upload_missing') }}
      </span>
      <span v-if="!configuration.is_logo_print">
        {{ configuration.label }}
      </span>
    </td>

    <td v-else>
      <span v-if="configuration.is_logo_print && configuration.upload !== null" class="text-primary">
        {{ configuration.upload.original_name }} ({{ $t('configurator.labels.deleted') }})
      </span>
      <span v-if="configuration.is_logo_print && configuration.upload === null" class="mr-2 bg-warning">
        <i class="fa fa-warning text-warning"></i> {{ $t('configurator.labels.upload_missing') }}
      </span>
      <span v-if="!configuration.is_logo_print">
        {{ configuration.label }}
      </span>
    </td>
  </tr>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useMainStore } from '@/store'
import { PRINT_CLOUD_STATUS_FINISHED } from '@/constants'
import Logger from '@/services/logging'

const store = useMainStore()
/** @type {Logger} */
const Log = inject('logger')
// define props
const props = defineProps({
  refinement: {
    type: Object,
    required: true
  }
})
// define emits
const emit = defineEmits(['download', 'show'])
// define computed props
const locale = computed(() => store.settings.locale)
const cloud = computed(() => store.tmp.cloud)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const name = computed(() => {
  if (props.refinement.booth_refinement === null) {
    Log.info('missing booth refinement - check for deleted_at', props.refinement)

    return ''
  }

  return (inEnglish.value)
    ? props.refinement.booth_refinement.name_en
    : props.refinement.booth_refinement.name
})

const articleName = computed(() => {
  return (inEnglish.value)
    ? props.refinement.article.name_en
    : props.refinement.article.name
})

const configuration = computed(() => {
  return props.refinement.configurations[0]
})
// define methods
const show = () => {
  emit('show', props.refinement.article)
}

const download = () => {
  emit('download', configuration.value.upload)
}
</script>